import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reportData: { result: [], status: "loading", message: "" },
  recentlyViewedReports: { result: [], status: "loading", message: "" },
  favoritesData: { result: [], status: "loading", message: "" },
  dataCatalogTemplate: { result: [], status: "loading", message: "" },
  dataCatalogData: { result: {}, status: "loading", message: "" },
  importedData: { result: [], status: "loading", message: "" },
  usersData: { result: [], status: "loading", message: "" },
  dataCatalogFilterValues: {
    dataProduct: [],
    productLines: [],
    region: [],
    dataSource: [],
  },
  explore: {
    tabCount: {
      loading: true,
      count: {
        groupReport: 0,
        dataPorduct: 0,
        dataAsset: 0,
      },
    },
  },
  filterOptionsList: {
    result: {
      // functions: [],
      // platforms: [],
      // regions: [],
      // tags: [],
      // datasources: [],
      // access_type: [],
    },
    status: "loading",
    message: "",
  },
  bannerData: { result: {}, status: "loading", message: "" },
  templateData: { result: [], status: "loading", message: "" },
  ownersData: { result: [], status: "loading", message: "" },
  myData: { result: {}, status: "loading", message: "" },
  reportDetailsData: { result: {}, status: "loading", message: "" },
  applicationSuggestionsData: { result: [], status: "loading", message: "" },
  activeApplicationData: { result: [], status: "loading", message: "" },
  discoverActiveTab: 0,
  dataLineage: { result: [], status: "loading", message: "" },
  activeAccessManagement: { result: [], status: "loading", message: "" },
  oktaSearchUsers: { result: [], status: "loading", message: "" },
  userDataModelData: { result: {}, status: "loading", message: "" },
  goldLayerTablesData: { result: {}, status: "loading", message: "" },
  recommendedAppData: { data: [], status: "loading", message: "" },
  helpSectionData: { result: {}, status: "loading", message: "" },
  applicationDetailsAccessData: { result: {}, status: "loading", message: "" },
  currentAppsData: {},
  // activeDataProduct: {
  //   app_category: "",
  //   app_desc:
  //     "Performance tracking tools to monitor the company’s key performance indicators (KPIs) effectively, along with a tracker for market information focusing on sales value and volume.",
  //   app_functions: [],
  //   app_name: "LATAM",
  //   app_product_lines: [
  //     "Scorecard",
  //     "Customer Scorecard",
  //     "Weekly Monitor Nutrition",
  //   ],
  //   app_product_streams: ["Cross", "Marketing"],
  //   app_regions: ["Mexico"],
  //   count: {
  //     Dataset: 48,
  //     Report: 8,
  //   },
  //   id: 8,
  //   is_dq_applied: false,
  //   owned_by: [
  //     {
  //       email: "duberney.arcilacastano@reckitt.com",
  //       name: "Duberney Arcila",
  //       role: "RPM",
  //     },
  //     {
  //       email: "esdras.orozco@reckitt.com",
  //       name: "Esdras Orozco",
  //       role: "RPM",
  //     },
  //   ],
  // },
  activeDataProduct: {},
  activeDataProductName: "",
  discoverTabCount: { count: [], status: "loading" },
  rapidData: {
    detailsJson: [],
    infraJson: [],
    accLibraryJson: {},
    aiModelJson: {
      usecases: [],
      priority_1: "",
      priority_2: "",
      priority_3: "",
    },
    isAppOwner: false,
    current_status: "",
    total_cost: "loading",
  },
  devops_dev:{},
  devops_prod:{},
  sigviewAutomation: {
    sigviewMetadata: {
      data: [],
      loading: true,
      error: "",
    },
  },
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    updateReportData(state, action) {
      state.reportData = action.payload;
    },
    updateTemplateData(state, action) {
      state.templateData = action.payload;
    },
    updateOwnersData(state, action) {
      state.ownersData = action.payload;
    },
    updateRecentlyViewedReports(state, action) {
      state.recentlyViewedReports = action.payload;
    },
    updateFavoritesData(state, action) {
      state.favoritesData = action.payload;
    },
    updateDataCatalogTemplateData(state, action) {
      state.dataCatalogTemplate = action.payload;
    },
    updateDataCatalogData(state, action) {
      state.dataCatalogData = action.payload;
    },
    updateFavoritedInReportData(state, action) {
      state.reportData.result = state.reportData.result.map((row) =>
        action.payload.reportId === row.id
          ? { ...row, favorited: action.payload.favorited }
          : row
      );
      if (state.recentlyViewedReports.result.length) {
        state.recentlyViewedReports.result =
          state.recentlyViewedReports.result.map((row) =>
            action.payload.reportId === row.id
              ? { ...row, favorited: action.payload.favorited }
              : row
          );
      }
    },
    updateFavoritedInFavouritesData(state, action) {
      state.favoritesData.result = state.favoritesData.result.filter(
        (row) => action.payload.reportId !== row.id
      );
    },
    updateFilterOptionsList(state, action) {
      state.filterOptionsList = action.payload;
    },
    resetData(state, action) {
      const { key } = action.payload;
      state[key] = initialState[key];
    },
    updateImportedData(state, action) {
      state.importedData = action.payload;
    },
    updateUsersData(state, action) {
      state.usersData = action.payload;
    },
    updateUsersRoleById(state, action) {
      const { user_id, user_type } = action.payload;
      state.usersData.result = state.usersData.result.map((user) => {
        if (user.user_id === user_id) {
          return { ...user, user_type: user_type };
        } else {
          return user;
        }
      });
    },
    updateImportedDataById(state, action) {
      const { report_id, status, modified_by, modified_on } = action.payload;
      state.importedData.result = state.importedData.result.map((report) => {
        if (report.id === report_id) {
          return {
            ...report,
            status: status,
            modified_by: modified_by,
            modified_on: modified_on,
          };
        } else {
          return report;
        }
      });
    },
    updateBannerData(state, action) {
      state.bannerData = action.payload;
    },
    updateGoldTableReports(state, action) {
      state.goldTableReportsData = action.payload;
    },
    updateMyAppsData(state, action) {
      state.myData = action.payload;
    },
    updateReportDetailsData(state, action) {
      state.reportDetailsData = action.payload;
    },
    updateApplicationSuggestionsData(state, action) {
      state.applicationSuggestionsData = action.payload;
    },
    updateActiveApplicationData(state, action) {
      state.activeApplicationData = action.payload;
    },
    updateDataLineage(state, action) {
      state.dataLineage = action.payload;
    },
    updateReportLineage(state, action) {
      state.dataLineage = action.payload;
    },
    updateAccessManagement(state, action) {
      state.activeAccessManagement = action.payload;
    },
    updatePendingRequests(state, action) {
      state.activePendingRequests = action.payload;
    },
    updateOktaSearchUsers(state, action) {
      state.oktaSearchUsers = action.payload;
    },
    updateUserDataModel(state, action) {
      state.userDataModelData = action.payload;
    },
    goldLayerTables(state, action) {
      state.goldLayerTablesData = action.payload;
    },
    updateRecommendedAppData(state, action) {
      state.recommendedAppData = action.payload;
    },
    helpSection(state, action) {
      state.helpSectionData = action.payload;
    },
    updateApplicationDetailsAccessData(state, action) {
      state.applicationDetailsAccessData = action.payload;
    },
    updateCurrentAppsData(state, action) {
      state.currentAppsData = action.payload;
    },
    updateActiveDataProduct(state, action) {
      state.activeDataProduct = action.payload;
    },
    updateActiveDataProductName(state, action) {
      state.activeDataProductName = action.payload;
    },
    updateDiscoverTabCount(state, action) {
      state.discoverTabCount = action.payload;
    },
    updateRapidInfraData(state, action) {
      state.rapidData = {
        ...state.rapidData,
        infraJson: action.payload,
      };
    },

    updateSigviewMetadata(state, action) {
      state.sigviewAutomation = {
        ...state.sigviewAutomation,
        sigviewMetadata: action.payload,
      };
    },
    updateRapidDetailsData(state, action) {
      state.rapidData = {
        ...state.rapidData,
        detailsJson: action.payload,
      };
    },
    updateAIModelsData(state, action) {
      state.rapidData = {
        ...state.rapidData,
        aiModels: action.payload,
      };
    },
    updateAIModelsJsonData(state, action) {
      state.rapidData = {
        ...state.rapidData,
        aiModelJson: action.payload,
      };
    },
    updateSelectedAIModel(state, action) {
      state.rapidData = {
        ...state.rapidData,
        selectedAIModel: action.payload,
      };
    },
    updateRapidAppStatus(state, action) {
      state.rapidData = {
        ...state.rapidData,
        current_status: action.payload,
      };
    },
    updateTotalCostData(state, action) {
      state.rapidData = {
        ...state.rapidData,
        total_cost: action.payload,
      };
    },
    updateDataCatalogSelectedFilters(state, action) {
      state.dataCatalogFilterValues = action.payload;
    },
    updateActiveDiscoverTab(state, action) {
      state.discoverActiveTab = action.payload;
    },
    updateDevopsDevData(state, action) {
      state.devops_dev = action.payload;
    },
    updateDevopsProdData(state, action) {
      state.devops_prod = action.payload;
    },
    updateAccLibraryJsonData(state, action) {
      state.rapidData = {
        ...state.rapidData,
        accLibraryJson: action.payload,
      };
    },
  },
});

export const {
  resetData,
  updateReportData,
  updateTemplateData,
  updateOwnersData,
  updateRecentlyViewedReports,
  updateFavoritesData,
  updateDataCatalogTemplateData,
  updateDataCatalogData,
  updateFilterOptionsList,
  updateFavoritedInReportData,
  updateFavoritedInFavouritesData,
  updateImportedData,
  updateUsersData,
  updateUsersRoleById,
  updateImportedDataById,
  updateBannerData,
  updateGoldTableReports,
  updateMyAppsData,
  updateReportDetailsData,
  updateApplicationSuggestionsData,
  updateActiveApplicationData,
  updateDataLineage,
  updateReportLineage,
  updateAccessManagement,
  updatePendingRequests,
  updateOktaSearchUsers,
  updateUserDataModel,
  goldLayerTables,
  updateRecommendedAppData,
  helpSection,
  updateApplicationDetailsAccessData,
  updateCurrentAppsData,
  updateActiveDataProduct,
  updateDiscoverTabCount,
  updateRapidInfraData,
  updateRapidDetailsData,
  updateAIModelsData,
  updateAIModelsJsonData,
  updateSelectedAIModel,
  updateRapidAppStatus,
  updateTotalCostData,
  updateSigviewMetadata,
  updateDataCatalogSelectedFilters,
  updateActiveDiscoverTab,
  updateActiveDataProductName,
  updateDevopsDevData,
  updateDevopsProdData,
  updateAccLibraryJsonData,
} = dataSlice.actions;
export default dataSlice.reducer;
